export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  ESC: 'Escape',
  SPACE: ' ',
};
